import { createFileRoute, redirect } from '@tanstack/react-router';

import { requirePermissionRoute } from '../../../lib/permissions.ts';

const guard = requirePermissionRoute('sales.use');

export const Route = createFileRoute('/_app/sales/')({
  beforeLoad: async (context) => {
    await guard(context);
    throw redirect({ to: '/sales/leads', replace: true });
  },
});
